export function getDisplayName(args) {
  return `Creating ${args.path}...`;
}
